import StatusSelect from './StatusSelect';

export default StatusSelect;
